import React, { useState, useRef, useEffect } from 'react';
import { TrendingUp, TrendingDown, Wallet, LogOut, ChevronDown, RotateCcw, Search, Calendar } from 'lucide-react';

const TerminalHeader = ({
  user,
  logout,
  selectedCoin,
  livePrices,
  accountValue,
  portfolio,
  unrealizedPnL,
  unrealizedPnLPercent,
  handleResetAccount,
  priceFlash,
  onOpenCoinSelector,
  onOpenPnLCalendar
}) => {
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);

  // Close profile dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    };
    if (profileOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [profileOpen]);

  return (
    <header className="terminal-header">
      <div className="brand-section">
        <h2>CryptoTerminal</h2>
        {selectedCoin && (
          <div className="active-coin-info" onClick={onOpenCoinSelector} title="Symbol Search (Alt+S)" style={{ cursor: 'pointer', padding: '6px 12px', borderRadius: '6px', backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', gap: '12px', transition: 'all 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.08)'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.03)'}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Search size={16} color="var(--text-secondary)" />
              <span className="ticker-label" style={{ fontSize: '0.9rem', fontWeight: '600' }}>{selectedCoin.symbol.toUpperCase()} / USDT</span>
            </div>
            <span className={`ticker-price ${priceFlash[selectedCoin.symbol.toLowerCase()] || ''}`} style={{ fontSize: '0.9rem' }}>
              ${(livePrices[selectedCoin.symbol.toLowerCase()] || selectedCoin.current_price || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 4 })}
            </span>
            <span className={`ticker-change ${selectedCoin.price_change_percentage_24h >= 0 ? 'positive' : 'negative'}`} style={{ fontSize: '0.8rem' }}>
              {selectedCoin.price_change_percentage_24h >= 0 ? '+' : ''}{selectedCoin.price_change_percentage_24h?.toFixed(2)}%
            </span>
            <ChevronDown size={14} color="var(--text-secondary)" />
          </div>
        )}
      </div>

      <div className="account-summary">
        <div className="stat-box">
          <span className="stat-label">Net Asset Value (USD)</span>
          <span className="stat-value">${accountValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        </div>
        <div className="stat-box">
          <span className="stat-label">Available Balance</span>
          <span className="stat-value flex-align">
            <Wallet size={14} className="stat-icon" /> ${portfolio.balance?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>
        <div className="stat-box">
          <span className="stat-label">Unrealized PnL</span>
          <span className={`stat-value flex-align ${unrealizedPnL >= 0 ? 'positive' : 'negative'}`}>
            {unrealizedPnL >= 0 ? <TrendingUp size={14} className="stat-icon" /> : <TrendingDown size={14} className="stat-icon" />}
            {unrealizedPnL >= 0 ? '+' : ''}${unrealizedPnL.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ({unrealizedPnLPercent >= 0 ? '+' : ''}{unrealizedPnLPercent.toFixed(2)}%)
          </span>
        </div>
        <div className="user-profile-wrapper" ref={profileRef}>
          <button className="user-profile-btn" onClick={() => setProfileOpen(!profileOpen)}>
            <div className="user-profile-avatar">{user?.name?.charAt(0)?.toUpperCase() || 'U'}</div>
            <span>{user?.name || 'User'}</span>
            <ChevronDown size={14} />
          </button>
          {profileOpen && (
            <div className="user-profile-dropdown">
              <div className="user-profile-dropdown-header">
                <div className="user-profile-dropdown-name">{user?.name}</div>
                <div className="user-profile-dropdown-email">{user?.email}</div>
              </div>
              <div className="user-profile-dropdown-divider" />
              <button className="user-profile-dropdown-item" onClick={() => { handleResetAccount(); setProfileOpen(false); }}>
                <RotateCcw size={14} /> Reset Demo Account
              </button>
              <button className="user-profile-dropdown-item" onClick={() => { onOpenPnLCalendar(); setProfileOpen(false); }}>
                <Calendar size={14} /> PnL Calendar
              </button>
              <div className="user-profile-dropdown-divider" />
              <button className="user-profile-dropdown-item danger" onClick={logout}>
                <LogOut size={14} /> Log Out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default TerminalHeader;
